
import { Vue, Component } from 'vue-property-decorator'
import { getSignGuarantee } from '@/api/guarantee'
@Component
export default class FileList extends Vue {
  // guaranteeId = ''
  fileName = '' // 文件名称
  fileUrl = '' // 文件连接
  created() {
    console.log('guaranteeId', this.$route.query)
    // this.guaranteeId = (this.$route.query as any).guaranteeId
    this.getSignGuarantee()
  }
  handleBack() {
    this.$router.go(-1)
  }
  // 确定签署
  handleClick() {
    this.$router.push({
      name: 'GuaranteeFace',
      query: this.$route.query
    })
  }
  toInfo() {
    this.$router.push({
      name: 'GuaranteeInfo',
      query: {
        fileUrl:this.fileUrl,
        fileName:this.fileName
      }
    })
  }
  // 查询担保确认函
  getSignGuarantee() {
    this.$store.state.user.info.userId = this.$route.query.opUser
    let params = {
      guaranteeId: this.$route.query.guaranteeId,
      companyId: this.$route.query.companyId
    }
    getSignGuarantee(params).then(res => {
      console.log('res',res);
      
      this.fileName = res.data[0].fileName
      this.fileUrl = res.data[0].fileUrl
      console.log('res111',this.fileUrl);
    })
  }
}
